// extracted by mini-css-extract-plugin
export default {"User":"styles_User__nsoSg","photo":"styles_photo__8TvS6"};